import styles from "./HrmStatusCard.module.css";

const formatAmount = (num) => {
  if (num === undefined || num === null) return "";
  if (num >= 100000)
    return `₹${(num / 100000).toFixed(num % 100000 === 0 ? 0 : 1)}L`;
  if (num >= 1000) return `₹${(num / 1000).toFixed(num % 1000 === 0 ? 0 : 1)}K`;
  return `₹${num}`;
};

const HrmStatusCard = ({
  mode,
  statusText,
  statusItemCount,
  amount,
  subtitle,
}) => {
  return (
    <div className={styles.card}>
      <div className={`${styles.label} ${mode ? styles.labelDark : ""}`}>
        {statusText}
      </div>
      <div className={`${styles.value} ${mode ? styles.valueDark : ""}`}>
        {amount !== undefined ? formatAmount(amount) : (statusItemCount ?? 0)}
      </div>
      {subtitle && (
        <div
          className={`${styles.subtitle} ${mode ? styles.subtitleDark : ""}`}
        >
          {subtitle}
        </div>
      )}
    </div>
  );
};

export default HrmStatusCard;
